import React from "react";
import { useParams } from "react-router-dom";
import UpdateAgencyBreadCrumb from "./UpdateAgencyBreadCrumb";
import UpdateRenewableAgency from "./UpdateRenewableAgency";

function UpdateRenewableAgencyPage() {
  const { id } = useParams(); // Get id from the URL

  return (
    <div className="container-fluid">
      <UpdateAgencyBreadCrumb />
      <UpdateRenewableAgency id={id} />
    </div>
  );
}

export default UpdateRenewableAgencyPage;
